import { render, staticRenderFns } from "./LempelZiv.vue?vue&type=template&id=3c4fa933&scoped=true&"
import script from "./LempelZiv.vue?vue&type=script&lang=js&"
export * from "./LempelZiv.vue?vue&type=script&lang=js&"
import style0 from "./LempelZiv.vue?vue&type=style&index=0&id=3c4fa933&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4fa933",
  null
  
)

export default component.exports